import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import _ from "lodash";
import { useStyles } from "./styles";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpArrowDown as upDownIcon } from "@fortawesome/pro-light-svg-icons";
import { ROUTINE_TYPE } from "../../../../constants/index";
import { useForm, Controller } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ActionForm from "./ActionForm";
import {useCoreEntityContext} from "../../../../hooks/useCoreEntitySlice";
import {selectContextEntity} from "../../../../state/slices/CoreEntity";
import { Tooltip } from "@material-ui/core";

export const GateOpenCloseActionFormAddEditSchema = Yup.object().shape({
    Device: Yup.array().min(1, "At least one device must be selected"),
    Gate: Yup.string().required("Required"),
});

const GateOpenCloseActionForm = ({ handleSave, handleCancel, action }) => {
  const classes = useStyles();
  const [entities, setEntities] = useState([]);
  const useCoreEntitySlice = useCoreEntityContext();
  const devicesInFacility = useSelector((state) => _.orderBy((useCoreEntitySlice ? selectContextEntity(state).children : state.entities.Context.children), ["name"], ["asc"]),
          shallowEqual
      );

  const GetDevices = () => {
    if (Array.isArray(devicesInFacility)) {
      var devices = devicesInFacility?.map((device) => {
        return { name: device?.name, value: device?.entityid };
      });
      setEntities(devices);
    }
  };

  const formatAndSave = (values) => {
    const switchGate = {
      payload: {
        Device: values.Device,
        Gate: values.Gate,
      },
      actionTypeID: ROUTINE_TYPE.GATES,
      order: action?.order ?? 0,
    };
    handleSave(switchGate);
  };

  const defaults = {
    Device: action?.payload?.Device ?? [],
    Gate: action?.payload?.Gate ?? "",
  };

  const GATE_STATUS_OPTIONS = [
    { value: 1, label: "Open" },
    { value: 2, label: "Closed" },
  ];
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: defaults,
    resolver: yupResolver(GateOpenCloseActionFormAddEditSchema),
  });

  useEffect(() => {GetDevices();}, []);
  
  return (
    <>
      <ActionForm
        handleSave={formatAndSave}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        icon={<FontAwesomeIcon icon={upDownIcon} />}
        edit={action}
        primaryText={"Gates"}
        secondaryText={"Open/Close"}
      >
        <Grid container className={clsx([classes.drawerContainer])}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Controller
              name="Device"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth variant="outlined">
                  <Grid container>
                    <Grid container item xs={12} sm={4} alignItems="center">
                      <Typography
                        variant="subtitle1"
                        id="Device"
                        className={clsx([classes.deviceLabel])}
                      >
                        Device
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Select
                        {...field}
                        multiple
                        fullWidth
                        displayEmpty
                        data-id={"deviceSelect"}
                        data-testid={"deviceSelect"}
                        value={field.value || []}
                        onChange={(event) => {
                          const selectedValues = event.target.value;
                          field.onChange(selectedValues);
                        }}
                        className={clsx([classes.deviceDropdown])}
                        variant="outlined"
                        inputProps={{
                          id: "device-dropdown",
                        }}
                        error={!!errors.Device}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return <em>Select device(s)</em>;
                          }
                          if (selected.length === 1) {
                            const selectedDevice = entities.find(
                              (d) => d.value === selected[0]
                            );
                            return selectedDevice?.name || "Unknown";
                          }

                          const selectedNames = selected
                            .map(
                              (id) => entities.find((d) => d.value === id)?.name
                            )
                            .filter(Boolean);

                          return (
                            <Tooltip
                              title={selectedNames.join(", ")}
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <span>Multiple devices</span>
                            </Tooltip>
                          );
                        }}
                      >
                        {entities.map((item) => (
                          <MenuItem key={item.value} value={item.value}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.Device && (
                        <div className={clsx([classes.selectError])}>
                          {errors.Device.message}
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Controller
              name="Gate"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth FormLabel="Gate" variant="outlined">
                  <Grid container>
                    <Grid container item xs={12} sm={4} alignItems="center">
                      <Typography
                        variant="subtitle1"
                        id="Gate"
                        className={clsx([classes.gateLabel])}
                      >
                        Gate
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Select
                        {...field}
                        fullWidth
                        displayEmpty
                        data-id={"gateSelect"}
                        data-testid={"gateSelect"}
                        data-value={field?.value}
                        className={clsx([classes.gateDropdown])}
                        variant="outlined"
                        inputProps={{
                          id: "gate-dropdown",
                        }}
                        error={!!errors.Gate}
                        helperText={errors.Gate && errors.Gate.message}
                      >
                        {GATE_STATUS_OPTIONS.map((gate) => (
                          <MenuItem key={gate.value} value={gate.label}>
                            {gate.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.Gate && (
                        <div className={clsx([classes.selectError])}>
                          {errors.Gate.message}
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </FormControl>
              )}
            />
          </Grid>
        </Grid>
      </ActionForm>
    </>
  );
};
export default GateOpenCloseActionForm;